
<div class="row p-3 wccard">
  <div class="w-100">
    <div class="d-flex aling-item-center">
      <div class="d-flex justify-content-center align-items-center"
        style="width: 61px; height: 61px; background-color: #FDFD6869; border-radius: 4px;">
        <i style="font-size: 36px; font-weight: 900; color: #EBEB4F;" class="fa-solid fa-stars"></i>
      </div>
      <div class="ml-1 d-flex flex-column">
        <span class="f-14 font-weight-500" style="color: #969696;">Plan Name</span>
        <span class="f-24 font-weight-600 mt-1" style="color: #484B59;">{{currentPlanDetails?.paymentplanname}}</span>
      </div>
    </div>
  </div>
</div>

<div class="row wccard p-3 mt-1">
  <div class="w-100">
    <div>
      <span class="f-14 font-weight-600" style="color: #484B59;">Plan Details</span>
    
      <div class="plan-details" *ngFor="let item of [
          { label: 'Plan Name', value: currentPlanDetails?.paymentplanname },
          { label: 'Plan Type', value: currentPlanDetails?.plantype },
          { label: 'Price', value: currentPlanDetails?.plancost },
          { label: 'Start Date', value: (currentPlanDetails?.paymentplanstartdate | date: 'MMM dd, yyyy') },
          { label: 'End Date', value: (currentPlanDetails?.paymentplanenddate | date: 'MMM dd, yyyy') }
        ]">
        <div class="d-flex justify-content-between">
          <span class="plan-details-name">{{ item.label }}</span>
          <span class="plan-details-value">{{ item.value }}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="row wccard p-3 mt-1">
  <span class="f-14 font-weight-600" style="color: #484B59;">Payment History</span>
</div>

<!-- For History -->
<div class="row mt-1">

  <!-- If history Not Available -->
    <div *ngIf="allHistory.length == 0" class="col wccard">
      <div class="w-100" style="height: 439px; display: flex; justify-content: center; align-items: center;">
        <div  class="text-center">
          <img style="width: 203px; height: 132px;" src="../../../assets/empty-credit.png" alt="empty_logo">
          <p class="f-14 font-weight-500" style="color: #969696;">No Team Members Yet, Start Inviting!</p>
        </div>
      </div>
    </div>

  <!-- If history Available -->
  <div class="col" *ngIf="allHistory.length > 0">
    <div class="row align-items-center p-2" style="background-color: #F7F7F7;">
     
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Plan Name
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Price
        </span>
      </div>
      <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Transaction Date
        </span>
      </div>

         <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Valid Upto
        </span>
      </div>

         <div class="col">
        <span class="f-14 font-weight-400" style="color: #969696;">
          Transaction ID
        </span>
      </div>
    </div>

    <div class="row align-items-center p-2 wccard" style="margin-top: 1px;" *ngFor="let history of allHistory">
      <div class="col">
        <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{history?.paymentplanname}}</span>
        </span>
      </div>

      <div class="col">
          <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{history?.plancost}} / {{history?.plantype}}</span>
        </span>
      </div>

       <div class="col">
          <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{history?.paymentplanstartdate | date: 'MMM dd, yyyy'}}</span>
        </span>
      </div>

        <div class="col">
          <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{history?.paymentplanenddate | date: 'MMM dd, yyyy'}}</span>
        </span>
      </div>

        <div class="col">
          <span class="mb-1 pointer no-outline">
          <span class="font-weight-400" style="color: #484B59;">{{history?.transactionid}}</span>
        </span>
      </div>

    </div>
  </div>

</div>